import { render, staticRenderFns } from "./ProfilesList.vue?vue&type=template&id=0cd02706&scoped=true"
import script from "./ProfilesList.vue?vue&type=script&lang=js"
export * from "./ProfilesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd02706",
  null
  
)

export default component.exports